//An email reply from a customer arrives here: the SMTP daemon (apiv2/adminScripts/smtpServer.ts)
//stores it in planup_multi_message and relays it to the tenant's sockets, the router hands it to
//us. Same shape as WhatsappHandler.handleIncomingMessage - drop it straight into an open chat,
//otherwise raise the bell notification plus a toast.

export default {


    handleIncomingEmail(messageFromSocket) {

        if (!messageFromSocket)
            return;

        let msgGroup = messageFromSocket.msgGroup;

        let message = {
            msgGroup,
            contactId: messageFromSocket.contactId,
            customerId: messageFromSocket.customerId,
            typeOfMessage: 'email',
            emailAddress: messageFromSocket.emailAddress,
            subject: messageFromSocket.subject,
            message: messageFromSocket.body,
            incomingFromCustomer: true,
            created: new Date(),
        };


        //the header's whatsapp box lists mail threads too and counts these into its badge, the
        //same way it counts 'whatsappMessageArrived'. Emitted before the open-chat return below
        //so the count is right whatever the user is looking at.
        window.planup.$root.$emit('emailMessageArrived', message);


        //activeChats lives on the whatsapp handler but holds every open conversation - the chat
        //component (PlanupMultiMessagesChat) is shared and registers email threads there too
        let activeChats = window.planup.$handlers.whatsappHandler.activeChats;

        if (activeChats[msgGroup]) {
            activeChats[msgGroup].unshift(message);
            return;
        }


        //the bell: the row is already saved server side, this just puts it in the header live
        if (messageFromSocket.notification)
            window.planup.$store.commit('pushNotification', messageFromSocket.notification);


        let senderName = messageFromSocket.senderName || messageFromSocket.emailAddress;
        let notificationText = 'מייל חדש מ' + senderName;

        //the classes carry the payload - App.vue.clickOnNotification reads them off the toast to
        //know which conversation to open
        window.planup.$notify({
            type: `emailmessage customer${message.customerId} contact${message.contactId} group_${msgGroup}`,
            title: 'hidden',
            //same layout as the whatsapp toast: who it is on the right, the channel glyph
            //(the envelope, added in css) on the left
            text: `<i class="fa-regular fa-user emailMsgIcon"></i><div class="whatsappMsgBody">${notificationText}</div><div style="clear:both"></div>`,
        });

    },

}
